module.exports = "<h4 class=\"center\">\n  Validando Token...\n</h4>\n"